import classNames from 'clsx';
import React from 'react';

import type { Props as ButtonProps } from '@swf/components/StarsButton/StarsButton';
import Button from '@swf/components/StarsButton/StarsButton';

import styles from './CasinoFilter.scss';

/*
 * @deprecated
 */
interface Props extends ButtonProps {
  active?: boolean;
  hidden?: boolean;
}

const CasinoFilter: React.FC<Props> = ({ active, hidden, ...rest }) => (
  <Button
    className={classNames(styles.filter, active && styles.active, hidden && styles.hidden)}
    variant="filter"
    size="small"
    inverse
    {...rest}
  />
);

export default CasinoFilter;
